
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import './open-sans-bold.css';
import './open-sans-light.css';
import './open-sans-regular.css';

ReactDOM.render(
  <App/>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/